import {
  issueViewerSecondaryViewQueryKey,
  issueViewerSecondaryViewQueryOptions,
  // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports -- This direct options entrypoint has no runtime Relay dependency.
} from '@github-ui/issue-viewer/IssueViewerSecondaryViewQuery'
import type {IssueCoordinates} from '@github-ui/preheat-issues-manager/issue-viewer-query'
import {runSharedPreheat} from '@github-ui/preheat-issues-manager/shared-preheat-run'
import {createQueryClient, getQueryClient} from '@github-ui/query-client'
import type {SendAnalyticsEventFunction} from '@github-ui/use-analytics'

let preheatQueryClient: ReturnType<typeof createQueryClient> | undefined

export async function preheatIssueViewerSecondary({
  owner,
  repo,
  number,
  sendAnalyticsEvent,
  signal,
  onError,
}: IssueCoordinates & {
  sendAnalyticsEvent: SendAnalyticsEventFunction
  signal: AbortSignal
  onError: (error: unknown) => void
}): Promise<void> {
  const queryKey = issueViewerSecondaryViewQueryKey(owner, repo, number)
  const existingQuery = getQueryClient().getQueryCache().find({queryKey, exact: true})
  if (
    existingQuery &&
    (existingQuery.getObserversCount() > 0 ||
      existingQuery.state.fetchStatus !== 'idle' ||
      (existingQuery.state.status === 'success' && !existingQuery.state.isInvalidated))
  ) {
    return
  }

  // Like the primary, only write the persisted record without marking the issue as read. A viewer
  // restores it and then fetches with read marking, so it never joins this request.
  const preheatClient = (preheatQueryClient ??= createQueryClient())
  await runSharedPreheat({
    client: preheatClient,
    queryKey,
    signal,
    onError,
    fetch: () =>
      preheatClient.fetchQuery({
        ...issueViewerSecondaryViewQueryOptions({
          owner,
          repo,
          number,
          markAsRead: false,
          sendAnalyticsEvent,
          preheat: true,
        }),
        gcTime: 0,
      }),
  })
}
